import React, { useState } from "react";
import OverviewTab from "./OverviewTab";
import BloodDemandTab from "./BloodDemandTab";
import LocationAnalyticsTab from "./LocationAnalyticsTab";
import TimeAnalyticsTab from "./TimeAnalyticsTab";
import PredictionsTab from "./PredictionsTab";

const TABS = [
  { id: "overview", label: "Overview", icon: "fa-chart-line" },
  { id: "blood-demand", label: "Blood Demand", icon: "fa-droplet" },
  { id: "location", label: "Location", icon: "fa-map-location-dot" },
  { id: "time", label: "Time Patterns", icon: "fa-clock" },
  { id: "predictions", label: "Predictions", icon: "fa-brain" },
];

const AdminDemandAnalytics = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const renderTab = () => {
    switch (activeTab) {
      case "overview":
        return <OverviewTab />;
      case "blood-demand":
        return <BloodDemandTab />;
      case "location":
        return <LocationAnalyticsTab />;
      case "time":
        return <TimeAnalyticsTab />;
      case "predictions":
        return <PredictionsTab />;
      default:
        return <OverviewTab />;
    }
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Demand Analytics & Predictions</h1>

      <div className="tabs tabs-boxed bg-base-100 p-1 flex-wrap">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`tab gap-1 ${activeTab === tab.id ? "tab-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <i className={`fa-solid ${tab.icon}`}></i>
            <span className="hidden sm:inline">{tab.label}</span>
          </button>
        ))}
      </div>

      <div>{renderTab()}</div>
    </div>
  );
};

export default AdminDemandAnalytics;
